import { linePlot, periodInput } from "../definitionHelpers";
import { PALETTE } from "../palette";
import { PRICE_SOURCE } from "../indicatorTypes";
import { priceReader } from "../math/priceSources";
import { channelMiddleAt } from "../math/windowExtremes";

// As TV Ichimoku Cloud with Lagging Span = Kijun: the spans are moved
// Kijun − 1 bars right, the close Kijun − 1 bars left
const displacement = (inputs) => inputs.kijun - 1;

/**
 * Ichimoku Kinko Hyo (research §1.4), as TV Ichimoku Cloud: middles of the
 * high-low channels of Tenkan, Kijun and Senkou B bars, Span A their mean.
 */
export default {
  id: "ichimoku",
  name: "Ichimoku Kinko Hyo",
  isOscillator: false,
  inputs: [
    periodInput("tenkan", "Tenkan", 9),
    periodInput("kijun", "Kijun", 26),
    periodInput("senkouB", "Senkou B", 52),
  ],
  plots: [
    linePlot("tenkan", "Tenkan", PALETTE.LIME),
    linePlot("kijun", "Kijun", PALETTE.AQUA),
    linePlot("chikou", "Chikou", PALETTE.YELLOW, { shift: (inputs) => -displacement(inputs) }),
    linePlot("spanA", "Span A", PALETTE.ORANGE, { shift: displacement }),
    linePlot("spanB", "Span B", PALETTE.RED, { shift: displacement }),
  ],
  levels: [],

  calculate: (bars, inputs, series, fromIndex) => {
    const readHigh = priceReader(bars, PRICE_SOURCE.HIGH);
    const readLow = priceReader(bars, PRICE_SOURCE.LOW);

    for (let index = fromIndex; index < bars.length; index += 1) {
      const tenkan = channelMiddleAt(readHigh, readLow, index, inputs.tenkan);
      const kijun = channelMiddleAt(readHigh, readLow, index, inputs.kijun);

      series.tenkan[index] = tenkan;
      series.kijun[index] = kijun;
      series.chikou[index] = bars[index].close;
      series.spanA[index] = (tenkan + kijun) / 2;
      series.spanB[index] = channelMiddleAt(readHigh, readLow, index, inputs.senkouB);
    }
  },
};
